// Slot Machine Factory class
//
// Used to create a unique slot machine for cascading slots
//
// Slot machine class
//
// Used to create, spin and animate reels as a group
// Contains no logic.
//
// Add this class to config.json under the "controllers" section, telling it which reels it is managing
//      "controllers": {
//        "slotMachine": { "reels": [ "reel0", "reel1", "reel2", "reel3", "reel4"]}
//      }
//
// addInjectors - adds to a list of injector pre/post pairs
// selectInjectors - selects the injector pre/post pair defined in addInjectors
// setInjectors - sets injector pre/post pairs now
//
// infiniteSpin - starts the reels infinitely spinning
// stopReels - signals reels that are infinitely spinning to stop on positions
//

// For backward compatibility
GameSlotMachine = undefined;

GameSlotMachineFactory = {};
GameSlotMachineFactory.slotMachines = [];

//
GameSlotMachineFactory.createSlotMachine = function () {
  var newSlotMachine = {};
  newSlotMachine.reels = [];
  newSlotMachine.groupAnalysers = {};
  newSlotMachine.symbolCreationCallbacks = {};
  newSlotMachine.slamStopRequested = false;

  newSlotMachine.addReel = function (reelId) {
    if (resourceManager.get(reelId).Props.type !== 'cascadeReel') {
      console.error(
        "GameSlotMachine can only manage 'cascadeReels', " +
          reelId +
          " is type '" +
          resourceManager.get(reelId).Props.type +
          "'"
      );
      return;
    }

    var reel = resourceManager.get(reelId);
    reel.reelIndex = this.reels.length;
    this.reels.push(reel);
  };

  newSlotMachine.initialise = function (json) {
    var containerName = json.containerName;
    var stripContainer = resourceManager.hasResource(containerName + ':reelStripContainer')
      ? resourceManager.get(containerName + ':reelStripContainer')
      : undefined;
    var boxContainer = resourceManager.hasResource(containerName + ':reelBoxContainer')
      ? resourceManager.get(containerName + ':reelBoxContainer')
      : undefined;

    newSlotMachine.createColossalParticleEmitters();

    for (var i = 0; i < json.reels.length; ++i) {
      this.addReel(containerName + ':reelContainer:' + json.reels[i]);

      if (stripContainer !== undefined) {
        stripContainer.addChild(this.reels[i].animationStripContainer);
      }

      if (boxContainer !== undefined) {
        boxContainer.addChild(this.reels[i].animationBoxContainer);
      }
    }

    // lets add an overall mask to the reelContainer
    // this should help with colossals, and it means we dont need masks on the reels
    const reelContainer = resourceManager.get('slotContainer:reelContainer');
    const mask = new PIXI.Graphics();
    mask.beginFill(0xff0000, 1);
    mask.drawRect(55, 70, 786, 560);
    mask.endFill();
    reelContainer.mask = mask;
    reelContainer.addChild(mask);
  };

  newSlotMachine.clearReels = function (colossalData) {
    newSlotMachine.slamStopRequested = false;
    const delays = this.createClearReelDelays(colossalData);
    console.log('calculated clear reel delays are', delays);
    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].clearReel(delays[i]);
    }
  };

  newSlotMachine.slamStop = function () {
    if (!newSlotMachine.slamStopRequested) {
      newSlotMachine.slamStopRequested = true;

      gameController.slamStop();

      for (var i = 0; i < this.reels.length; i++) {
        this.reels[i].requestSlamStop();
      }
    }
  };

  newSlotMachine.grab1x1Emitter = function (reel, row) {
    let emitter = newSlotMachine.colossalEmitters[`1x1`][reel][row];
    return emitter;
  };

  newSlotMachine.grabUnused3x3Emitter = function () {
    let emitter = null;
    for (let i = 0; i < newSlotMachine.colossalEmitters[`3x3`].length; i++) {
      if (newSlotMachine.colossalEmitters[`3x3`][i].visible === false) {
        emitter = newSlotMachine.colossalEmitters[`3x3`][i];
        break;
      }
    }
    return emitter;
  };

  newSlotMachine.grabUnused2x2Emitter = function () {
    let emitter = null;
    for (let i = 0; i < newSlotMachine.colossalEmitters[`2x2`].length; i++) {
      if (newSlotMachine.colossalEmitters[`2x2`][i].visible === false) {
        emitter = newSlotMachine.colossalEmitters[`2x2`][i];
        break;
      }
    }
    return emitter;
  };

  newSlotMachine.createColossalParticleEmitters = function () {
    // create pool of emitter2
    newSlotMachine.colossalEmitters = {
      '3x3': [],
      '2x2': [],
      '1x1': [],
    };

    // we need 2 emitters for 3x3
    for (let i = 0; i < 2; i++) {
      const emitter = particleManager.createEmitter(
        `3x3_emitter`,
        'slotContainer:particlesContainer:3x3particlesContainer',
        0,
        0,
        false
      );
      emitter.particleEmitter.emit = false;
      emitter.visible = false;
      newSlotMachine.colossalEmitters[`3x3`][i] = emitter;
      emitter.origParent = emitter.parent;
      emitter.parent.removeChild(emitter);
    }

    // we need 6 for 2x2
    for (let i = 0; i < 6; i++) {
      const emitter = particleManager.createEmitter(
        `2x2_emitter`,
        'slotContainer:particlesContainer:2x2particlesContainer',
        0,
        0,
        false
      );
      emitter.particleEmitter.emit = false;
      emitter.visible = false;
      newSlotMachine.colossalEmitters[`2x2`][i] = emitter;
      emitter.origParent = emitter.parent;
      emitter.parent.removeChild(emitter);
    }

    // we need 6 for 2x2
    for (let i = 0; i < 6; i++) {
      newSlotMachine.colossalEmitters[`1x1`][i] = [];
      for (let j = 0; j < 5; j++) {
        const emitter = particleManager.createEmitter(
          `1x1_emitter`,
          'slotContainer:particlesContainer:1x1particlesContainer',
          0,
          0,
          false
        );
        emitter.particleEmitter.emit = false;
        emitter.visible = false;
        newSlotMachine.colossalEmitters[`1x1`][i][j] = emitter;
        emitter.origParent = emitter.parent;
        emitter.parent.removeChild(emitter);
      }
    }

    // resourceManager.get('slotContainer:particlesContainer:1x1particlesContainer').visible = false;
    // resourceManager.get('slotContainer:particlesContainer:2x2particlesContainer').visible = false;
    // resourceManager.get('slotContainer:particlesContainer:3x3particlesContainer').visible = false;
  };

  newSlotMachine.resetColossalData = function () {
    const colossalData = [];
    for (let i = 0; i < this.reels.length; i++) {
      colossalData[i] = [];
      for (let j = 0; j < this.reels[i].symbolSprites.length; j++) {
        colossalData[i][j] = null;
      }
    }

    return colossalData;
  };

  newSlotMachine.generateColossalDataAfterPop = function (reels, convertToColossals) {
    const symbolIds = [];
    for (let i = 0; i < reels.length; i++) {
      const reel = reels[i];
      symbolIds[i] = [];
      for (let j = 0; j < reel.symbolSprites.length; j++) {
        const symbolSprites = reel.symbolSprites[j];
        const symbolData = reel.symbolData[j];
        if (symbolSprites.droppingInFromOff === true) {
          symbolIds[i][j] = symbolData.symbolId;
        } else {
          // isnt a new symbol, so we cant be using this as a colossal
          symbolIds[i][j] = -1;
        }
      }
    }

    const data = newSlotMachine.generateColossalData(symbolIds, convertToColossals);
    return data;
  };

  newSlotMachine.generateColossalData = function (symbolIds, convertToColossals) {
    // symbolIds is an array of reels and columns
    // we should go through the data looking for clumps of 2x2 and 3x3
    // if we find some, we can return an array which will look something like
    // const data = [
    //   [2, 2, 0, 0, 0],
    //   [2, 2, 0, 0, 0],
    //   [0, 0, 3, 3, 3],
    //   [0, 0, 3, 3, 3],
    //   [0, 0, 3, 3, 3],
    // ];

    const detected = [];
    const colossalData = [];
    for (let i = 0; i < symbolIds.length; i++) {
      detected[i] = [];
      colossalData[i] = [];
      for (let j = 0; j < symbolIds[i].length; j++) {
        detected[i][j] = 0;
        colossalData[i][j] = null;
      }
    }

    // this check is done here, because i still want to return full of nulls
    if (convertToColossals) {
      // look for 2x2 patterns, this will also include 3x3 - which we will look out for next
      for (let i = 0; i < symbolIds.length - 1; i++) {
        for (let j = 0; j < symbolIds[i].length - 1; j++) {
          if (
            symbolIds[i][j] !== -1 &&
            // symbolIds[i][j] !== 9 && // ignore wilds for now
            symbolIds[i][j] === symbolIds[i][j + 1] &&
            symbolIds[i][j + 1] === symbolIds[i + 1][j] &&
            symbolIds[i + 1][j] === symbolIds[i + 1][j + 1]
          ) {
            detected[i][j] = symbolIds[i][j] + 1;
            detected[i][j + 1] = symbolIds[i][j] + 1;
            detected[i + 1][j] = symbolIds[i][j] + 1;
            detected[i + 1][j + 1] = symbolIds[i][j] + 1;
          }
        }
      }

      let id = 0;
      // we now have data which can contain 2x2 and 3x3, now look for 3x3 and remove from detected
      for (let i = 0; i < detected.length - 2; i++) {
        for (let j = 0; j < detected[i].length - 2; j++) {
          if (
            detected[i][j] > 0 &&
            detected[i][j] === detected[i + 1][j] &&
            detected[i + 1][j] === detected[i + 2][j] &&
            detected[i + 2][j] === detected[i][j + 1] &&
            detected[i][j + 1] === detected[i + 1][j + 1] &&
            detected[i + 1][j + 1] === detected[i + 2][j + 1] &&
            detected[i + 2][j + 1] === detected[i][j + 2] &&
            detected[i][j + 2] === detected[i + 1][j + 2] &&
            detected[i + 1][j + 2] === detected[i + 2][j + 2]
          ) {
            // we have a 3x3 here
            const data = {
              size: 3,
              id: id,
              symbolId: detected[i][j] - 1,
            };
            colossalData[i][j] = data;
            colossalData[i + 1][j] = data;
            colossalData[i + 2][j] = data;
            colossalData[i][j + 1] = data;
            colossalData[i + 1][j + 1] = data;
            colossalData[i + 2][j + 1] = data;
            colossalData[i][j + 2] = data;
            colossalData[i + 1][j + 2] = data;
            colossalData[i + 2][j + 2] = {
              size: 3,
              id: id,
              symbolId: detected[i][j] - 1,
              spriteHere: true,
            };
            detected[i][j] = 0;
            detected[i + 1][j] = 0;
            detected[i + 2][j] = 0;
            detected[i][j + 1] = 0;
            detected[i + 1][j + 1] = 0;
            detected[i + 2][j + 1] = 0;
            detected[i][j + 2] = 0;
            detected[i + 1][j + 2] = 0;
            detected[i + 2][j + 2] = 0;
            id++;
          }
        }
      }

      // now we should be able to go through the detected array looking for 2x2 without
      // worrying about 3x3
      for (let i = 0; i < detected.length - 1; i++) {
        for (let j = 0; j < detected[i].length - 1; j++) {
          if (
            detected[i][j] > 0 &&
            detected[i][j] === detected[i][j + 1] &&
            detected[i][j + 1] === detected[i + 1][j] &&
            detected[i + 1][j] === detected[i + 1][j + 1]
          ) {
            // we have a 2x2 here
            const data = {
              size: 2,
              id: id,
              symbolId: detected[i][j] - 1,
            };
            colossalData[i][j] = data;
            colossalData[i + 1][j] = data;
            colossalData[i][j + 1] = data;
            colossalData[i + 1][j + 1] = {
              size: 2,
              id: id,
              symbolId: detected[i][j] - 1,
              spriteHere: true,
            };
            detected[i][j] = 0;
            detected[i + 1][j] = 0;
            detected[i][j + 1] = 0;
            detected[i + 1][j + 1] = 0;
            id++;
          }
        }
      }
    } else {
      console.log('colossals not wanted!');
    }

    return colossalData;
  };

  newSlotMachine.createClearReelDelays = function (colossalData, delay = 100) {
    let currentDelay = 0;
    const delays = [0]; // 1st is always 0
    if (!colossalData) {
      for (let i = 1; i < this.reels.length; i++) {
        currentDelay += delay;
        delays[i] = currentDelay;
      }
    } else {
      let currentDelay = 0;
      for (let i = 1; i < colossalData.length; i++) {
        let sameIDFound = false;
        for (let j = 0; j < colossalData[i].length && !sameIDFound; j++) {
          if (colossalData[i][j]) {
            // we have data here
            // now look to see if its the same id as the previous reel
            if (colossalData[i - 1][j] && colossalData[i - 1][j].id === colossalData[i][j].id) {
              sameIDFound = true;
            }
          }
        }
        if (!sameIDFound) {
          currentDelay += delay;
        }
        delays[i] = currentDelay;
      }
    }

    // before we return the delays
    // we should look at adjusting the delays based on minGameTime
    // uk is 2 seconds, de is 5 seconds
    // we will also be slowing the drop down a touch i think
    // if minGameTime < 2, then i dont think we need to worry?
    // i have added a check for de, but the adjustments work well for
    // license pt as well
    const license = gameData.license.toUpperCase();
    if (license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        let multiplier = minGameTime * 0.55;
        // do we want to cap the multiplier? YES!
        if (multiplier > 3) {
          multiplier = 3;
        }
        for (let i = 0; i < delays.length; i++) {
          delays[i] *= multiplier;
        }
      }
    }

    return delays;
  };

  newSlotMachine.createInitialDropDelays = function (colossalData, delay) {
    const startAnticipationDelayFromReel = gameController.startAnticipationDelayFromReel;
    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
    let currentDelay = 0;
    const delays = [0]; // 1st is always 0
    for (let i = 1; i < colossalData.length; i++) {
      let sameIDFound = false;
      for (let j = 0; j < colossalData[i].length && !sameIDFound; j++) {
        if (colossalData[i][j]) {
          // we have data here
          // now look to see if its the same id as the previous reel
          if (colossalData[i - 1][j] && colossalData[i - 1][j].id === colossalData[i][j].id) {
            sameIDFound = true;
          }
        }
      }
      if (!sameIDFound) {
        currentDelay += delay;
        if (startAnticipationDelayFromReel !== -2 && i === startAnticipationDelayFromReel + 1) {
          currentDelay += anticipationConfig.initialReelDelay;
        }

        if (startAnticipationDelayFromReel !== -2 && i > startAnticipationDelayFromReel + 1) {
          // when anticipating we are also adding increasing the gap time between symbols
          // so take then into account here
          const gapDelay = freespins.inFreespins ? anticipationConfig.gapDelayFS : anticipationConfig.gapDelay;
          const extraDelay = gapDelay * anticipationConfig.gapMultiplier * 5; // 4 as there isnt a gap on the 1st one
          currentDelay += extraDelay;
        }
      }
      delays[i] = currentDelay;
    }

    // before we return the delays
    // we should look at adjusting the delays based on minGameTime
    // uk is 2 seconds, de is 5 seconds
    // we will also be slowing the drop down a touch i think
    // if minGameTime < 2, then i dont think we need to worry?
    // i have added a check for de, but the adjustments work well for
    // license pt as well
    const license = gameData.license.toUpperCase();
    if (license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        let multiplier = minGameTime * 0.55;
        // do we want to cap the multiplier? YES!
        if (multiplier > 3) {
          multiplier = 3;
        }
        for (let i = 0; i < delays.length; i++) {
          delays[i] *= multiplier;
        }
      }
    }

    return delays;
  };

  newSlotMachine.createDropDelaysForOldSymbols = function (colossalData, popData, delay = 125) {
    let currentDelay = 0;
    const delays = [0]; // 1st is always 0

    // popData will let us know if something on the reel
    // is to drop, we need to count how many are dropping
    // if they are all dropping then we dont need a delay here
    let reelDropping = [];
    for (let i = 0; i < gameData.reels.length; i++) {
      let numNewDropping = 0;
      let numOldDropping = 0;
      reelDropping[i] = false;
      for (let j = 0; j < popData[i].length; j++) {
        if (popData[i][j]) {
          reelDropping[i] = true;
          // is this symbol old or new?
          if (gameData.reels[i].symbolSprites[j].droppingInFromOff === true) {
            numNewDropping++;
          } else {
            numOldDropping++;
          }
        }
      }

      if (numNewDropping === 5) {
        // all the symbols will be removed and all new symbol will be dropping in
        // reset back to false so the delay isnt incremented as we have no old symbols
        // to drop
        reelDropping[i] = false;
      }
    }

    for (let i = 1; i < reelDropping.length; i++) {
      if (reelDropping) {
        // currentDelay += delay;
      }
      delays[i] = currentDelay;
    }

    return delays;
  };

  newSlotMachine.createDropDelaysForNewSymbols = function (colossalData, popData, delay = 125) {
    const startAnticipationDelayFromReel = gameController.startAnticipationDelayFromReel;
    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
    let currentDelay = 0;
    const delays = [0]; // 1st is always 0
    const origDelay = 125;
    const colossalsOn = [];

    // popData will let us know if something on the reel
    // is to drop
    // if nothing is dropping, the delay isnt incremented
    let reelAnticipationExtraDelay = [];
    let reelDropping = [];
    for (let i = 0; i < gameData.reels.length; i++) {
      reelDropping[i] = false;
      reelAnticipationExtraDelay[i] = 0;
      for (let j = 0; j < popData[i].length; j++) {
        if (popData[i][j]) {
          reelDropping[i] = true;
          break;
        }
      }
    }

    if (startAnticipationDelayFromReel !== -2) {
      for (let i = 0; i < gameData.reels.length; i++) {
        const reel = gameData.reels[i];
        if (i > startAnticipationDelayFromReel) {
          let amountMoving = 0;
          const symbolSprites = reel.symbolSprites;
          for (let k = 0; k < symbolSprites.length; k++) {
            if (symbolSprites[k].droppingInFromOff === true) {
              amountMoving++;
            }
          }
          // delays between drops
          let extraDelay = 0;
          if (amountMoving) {
            const gapDelay = freespins.inFreespins ? anticipationConfig.gapDelayFS : anticipationConfig.gapDelay;
            extraDelay = gapDelay * anticipationConfig.gapMultiplier * (amountMoving - 1);
            if (amountMoving) {
              extraDelay += 400;
            }
          }
          reelAnticipationExtraDelay[i] += extraDelay;
        }
      }
    }

    // shouldnt need to check for colossal data as colossals are disabled
    // when anticipation is required
    for (let i = 1; i < colossalData.length; i++) {
      let sameIDFound = false;
      let reelDropping = false;

      for (let j = 0; j < colossalData[i].length && !sameIDFound; j++) {
        if (colossalData[i][j]) {
          // we have data here
          // now look to see if its the same id as the previous reel
          if (colossalData[i - 1][j] && colossalData[i - 1][j].id === colossalData[i][j].id) {
            sameIDFound = true;
            colossalsOn[i - 1] = true;
            colossalsOn[i] = true;
          }
        }
        if (popData[i][j]) {
          reelDropping = true;
        }
      }

      if (!sameIDFound && reelDropping) {
        currentDelay += delay;
      }
      delays[i] = currentDelay;
    }

    // now we have sorted out the delays for normal drops, have we got any anticipation delays?
    // lets add this delays
    let extraDelay = 0;
    for (let i = 0; i < delays.length; i++) {
      extraDelay += reelAnticipationExtraDelay[i];
      delays[i] += extraDelay;
    }

    // now normalise so there is no delay on 1st reel
    const adjust = delays[0];
    for (let i = 0; i < delays.length; i++) {
      delays[i] -= adjust;
    }

    return delays;
  };

  newSlotMachine.createDropDelays = function (colossalData, popData, delay = 125) {
    const startAnticipationDelayFromReel = gameController.startAnticipationDelayFromReel;
    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
    let currentDelay = 0;
    const delays = [0]; // 1st is always 0
    const origDelay = 125;
    const colossalsOn = [];

    // bit different this
    // popData will let us know if something on the reel
    // is to drop
    // if nothing is dropping, the delay isnt incremented
    let reelAnticipationExtraDelay = [];
    let reelDropping = [];
    for (let i = 0; i < gameData.reels.length; i++) {
      reelDropping[i] = false;
      reelAnticipationExtraDelay[i] = 0;
      for (let j = 0; j < popData[i].length; j++) {
        if (popData[i][j]) {
          reelDropping[i] = true;
          break;
        }
      }
    }

    if (startAnticipationDelayFromReel !== -2) {
      for (let i = 0; i < gameData.reels.length; i++) {
        if (i > startAnticipationDelayFromReel) {
          // cant assume 5 here, its the amount of symbols that are dropping
          // we can find that out from symbolDropDeltas
          let amountMoving = 0;
          const symbolDropDeltas = gameData.reels[i].symbolDropDeltas;
          for (let k = 0; k < symbolDropDeltas.length; k++) {
            if (symbolDropDeltas[k] > 0) {
              amountMoving++;
            }
          }
          // delays between drops
          let extraDelay = 0;
          if (amountMoving) {
            const gapDelay = freespins.inFreespins ? anticipationConfig.gapDelayFS : anticipationConfig.gapDelay;
            extraDelay = gapDelay * anticipationConfig.gapMultiplier * (amountMoving - 1);
            if (amountMoving) {
              extraDelay += 400;
            }
          }
          reelAnticipationExtraDelay[i] += extraDelay;
        }
      }
    }

    for (let i = 1; i < colossalData.length; i++) {
      let sameIDFound = false;
      let reelDropping = false;

      for (let j = 0; j < colossalData[i].length && !sameIDFound; j++) {
        if (colossalData[i][j]) {
          // we have data here
          // now look to see if its the same id as the previous reel
          if (colossalData[i - 1][j] && colossalData[i - 1][j].id === colossalData[i][j].id) {
            sameIDFound = true;
            colossalsOn[i - 1] = true;
            colossalsOn[i] = true;
          }
        }
        if (popData[i][j]) {
          reelDropping = true;
        }
      }

      if (!sameIDFound && reelDropping) {
        currentDelay += delay;
      }
      delays[i] = currentDelay;
    }

    // still something not quite right around here
    // works ok if anti from the start
    // but if you are starting after 1st reel, some delays seem way to long
    // and when mixed with colossals

    // now we have sorted out the delays for normal drops, have we got any anticipation delays?
    // lets add this delays
    let extraDelay = 0;
    for (let i = 0; i < delays.length; i++) {
      extraDelay += reelAnticipationExtraDelay[i];
      delays[i] += extraDelay;
    }

    // now normalise so there is no delay on 1st reel
    const adjust = delays[0];
    for (let i = 0; i < delays.length; i++) {
      delays[i] -= adjust;
    }

    return delays;
  };

  newSlotMachine.dropInitialSymbols = function (positions, eggMultiplierData = null, convertToColossals = false) {
    const colossalData = this.generateColossalData(positions, convertToColossals);
    const delays = this.createInitialDropDelays(colossalData, 100);
    console.log('calculated colossalData', colossalData);
    console.log('calculated initial drop delays are', delays);
    for (let i = 0; i < this.reels.length; ++i) {
      this.reels[i].fillInitialSymbols(delays[i], positions, eggMultiplierData, colossalData);
    }
    return colossalData;
  };

  newSlotMachine.convertColossalsIntoSmall = async function (colossalData) {
    newSlotMachine.convertingColossalsIntoSmall = true;

    await timerManager.delayAsync(500);

    soundManager.play('convertColossalsToSmall');

    // go through the array passed, looking for the symbol which
    // is the master colossal
    // this symbol to fade out and play an emitter
    // we have to wait for it to of disappeared 1st, because we are
    // using the same sprite
    // then as the symbol has faded out, fade in and scale in the small ones
    const promises = [];
    for (let i = 0; i < this.reels.length; ++i) {
      promises[i] = this.reels[i].animateRemovalOfColossalSymbols(colossalData[i]);
    }

    await Promise.all(promises);

    // now bring the missing small ones back in

    for (let i = 0; i < this.reels.length; ++i) {
      promises[i] = this.reels[i].revealSmallerAfterColossalSymbols(colossalData[i]);
    }

    await Promise.all(promises);

    await timerManager.delayAsync(500);

    newSlotMachine.convertingColossalsIntoSmall = false;
  };

  newSlotMachine.isconvertingColossalsIntoSmall = function () {
    return newSlotMachine.convertingColossalsIntoSmall;
  };

  newSlotMachine.stopReels = function (abovePositions, positions, belowPositions, postApperturePadding) {
    var allLandingSymbols = [];
    for (var i = 0; i < positions.length; ++i) {
      if (positions[i] === undefined) {
        allLandingSymbols.push(undefined);
      } else {
        allLandingSymbols.push(positions[i].slice());
      }
    }

    // Validate data sizes
    if (this.reels.length !== allLandingSymbols.length) {
      console.error(
        'Number of reels configured for slot machine (' +
          this.reels.length +
          ') is different to number of reel positions (' +
          allLandingSymbols.length +
          ')'
      );
      return;
    }

    for (var i = 0; i < this.reels.length; ++i) {
      if (allLandingSymbols[i] !== undefined) {
        if (this.reels[i].configParams.appertureHeight !== allLandingSymbols[i].length) {
          console.error(
            'Number of rows configured for slot ' +
              this.reels[i].Props.FQN +
              ' (' +
              this.reels[i].configParams.appertureHeight +
              ') is different to number of rows in positions (' +
              allLandingSymbols[i].length +
              ')'
          );
          return;
        }
      }
    }

    // Merge in above symbols
    if (abovePositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = abovePositions[i].length - 1; j >= 0; --j) {
          allLandingSymbols[i].unshift(abovePositions[i][j]);
        }
      }
    }
    // Merge in below symbols
    if (belowPositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = 0; j < belowPositions[i].length; ++j) {
          allLandingSymbols[i].push(belowPositions[i][j]);
        }
      }
    }

    if (postApperturePadding === undefined) {
      postApperturePadding = 0;
    }

    // Signal all reels to stop
    for (var i = 0; i < this.reels.length; ++i) {
      var reel = this.reels[i];

      reel.requestStop();
    }

    // Wait until all reels are ready to stop
    Reflex.addToUpdate(this.checkForStopReels);
  };

  newSlotMachine.checkForStopReels = function () {
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      if (!newSlotMachine.slamStopRequested /*&& !newSlotMachine.reels[i].preInjector.canStop*/) {
        return;
      }
    }

    // We can stop the reels
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      var reel = newSlotMachine.reels[i];
      reel.stop();
    }

    Reflex.removeFromUpdate(newSlotMachine.checkForStopReels);
  };

  GameSlotMachineFactory.slotMachines.push(newSlotMachine);

  if (GameSlotMachineFactory.slotMachines.length === 1) {
    // This is the first slot machine, so assign it to the global variable
    slotMachine = newSlotMachine;
  }

  return newSlotMachine;
};

GameSlotMachineFactory.onAbortGame = function () {
  // Retore state on all reels and injectors
  for (var slotMachineIndex = 0; slotMachineIndex < GameSlotMachineFactory.slotMachines.length; slotMachineIndex++) {
    var slotMachine = GameSlotMachineFactory.slotMachines[slotMachineIndex];
    for (var i = 0; i < slotMachine.reels.length; ++i) {
      slotMachine.reels[i].restoreState();
    }
  }
};

GameSlotMachineFactory.getSlotMachine = function (id) {
  if (typeof id === 'number') {
    // This is an index
    return GameSlotMachineFactory.slotMachines[id];
  } else {
    // This is a name
    for (var i = 0; i < GameSlotMachineFactory.slotMachines.length; i++) {
      if (GameSlotMachineFactory.slotMachines[i].name === id) return GameSlotMachineFactory.slotMachines[i];
    }

    console.log('Slot machine ' + id + ' was not found');
    return undefined;
  }
};

resourceManager.registerController('GameSlotMachine', GameSlotMachineFactory.createSlotMachine);

messageBus.subscribe('common:AbortGame', GameSlotMachineFactory.onAbortGame);
